module.exports = __webpack_public_path__ + "img/brand-logo.0e76f59.svg";